import { GatsbyImage } from "gatsby-plugin-image"
import React, { useEffect, useState } from "react"
import useAnimateInView from "../lib/useAnimateInView"

import { Navigation } from "swiper"
import "swiper/css"
import "swiper/css/navigation"
import { Swiper, SwiperSlide } from "swiper/react"

export const UpdateCarousel = ({ carouselItems }) => {
	const [distanceToMoveCarousel, setDistanceToMoveCarousel] = useState(0)

	useEffect(() => {
		function calculateDistanceToMove() {
			const container = document.querySelector("#team").querySelector(".max-1200.ma")
			setDistanceToMoveCarousel(Math.round(container.getBoundingClientRect().left) + parseInt(window.getComputedStyle(container, null).getPropertyValue("padding-left")))
		}

		calculateDistanceToMove()

		window.addEventListener("resize", calculateDistanceToMove)
		return () => window.removeEventListener("resize", calculateDistanceToMove)
	}, [])

	const section = useAnimateInView()
	return (
		<div className='inview' ref={section}>
			<Swiper
				slidesPerView={"3"}
				breakpoints={{
					0: { slidesPerView: 1.6 },
					500: { slidesPerView: 1.6 },
					768: { slidesPerView: 1.6 },
					990: { slidesPerView: 3 },
				}}
				slidesOffsetBefore={distanceToMoveCarousel}
				slidesOffsetAfter={distanceToMoveCarousel}
				spaceBetween={20}
				modules={[Navigation]}
				navigation
				className='multiColumnCarousel flex'
			>
				{carouselItems.map(item => {
					return (
						<SwiperSlide key={item.id}>
							<a href={item.youtube} target='_blank' rel='noreferrer' className=''>
								<div className='aspect-4-3 rel overflow'>
									<div className='play-icon' />
									<GatsbyImage className='bg-image br-08' image={item.thumbnail.gatsbyImageData} alt={item.thumbnail.alt || item.title || ''} />
								</div>
								{item.title && <p className='image-caption mb0'>{item.title}</p>}
							</a>
						</SwiperSlide>
					)
				})}
				<div className='mask left' />
				<div className='mask right' />
			</Swiper>
		</div>
	)
}
